import React from "react";

export const MerchantDetailContext = React.createContext(null);

export const useMerchantDetailContext = () => {
  const context = React.useContext(MerchantDetailContext);

  if (!context) throw new Error("Merchant Detail Context not provided!");

  return context;
};